import { SpinningLoader, ContextMenu } from 'common-components'
import MediaUploadButton from 'components/MediaUploadButton'
import { getUploadedImageActions } from '../utils'
import { useRef } from 'react'
import * as Styled from './styled'
import { IMobileUploadedImageViewProps } from '../types'

const MobileUploadedImageView: React.FC<IMobileUploadedImageViewProps> = ({
  referenceImageUrl,
  isUploading,
  handleFilesUpload,
  onMyFilesClick,
  handleRemoveImage
}) => {
  const uploadTriggerRef = useRef<{ triggerUpload: () => void } | null>(null)

  const handleUploadClick = () => {
    uploadTriggerRef.current?.triggerUpload()
  }

  // Actions for the dropdown menu
  const actionsData = getUploadedImageActions({
    handleUploadClick,
    onMyFilesClick,
    handleRemoveImage
  })

  return (
    <Styled.MobileUploadedImageContainer>
      {referenceImageUrl && (
        <Styled.UploadedImage src={referenceImageUrl} alt="Uploaded" />
      )}
      {!isUploading && (
        <>
          <ContextMenu
            actions={actionsData}
            absolutePosition={{ top: 12, right: 12 }}
            flyoutOptions={{
              position: 'bottom',
              alignmentX: 'right',
              extraOffset: 5
            }}
          />
          <MediaUploadButton
            acceptType="image"
            handleFilesUpload={handleFilesUpload}
            refTrigger={uploadTriggerRef}
          />
        </>
      )}
      {isUploading && (
        <Styled.LoadingOverlay>
          <SpinningLoader size={24} wrapperSize={40} loaderColor="#387DFF" />
        </Styled.LoadingOverlay>
      )}
    </Styled.MobileUploadedImageContainer>
  )
}

export default MobileUploadedImageView
